module.exports = __webpack_public_path__ + "img/sale_banner3.a48b5080.png";